module.exports = __webpack_public_path__ + "img/icon-arrow-right.eb4b4831.svg";